import React, { createContext, useContext, ReactNode } from 'react';
import { create } from 'zustand';

interface MetadataStore {
  additionalMetadata: Record<string, any>;
  updateMetadata: (key: string, value: any) => void;
  clearMetadata: () => void;
}

export const useMetadata = create<MetadataStore>((set) => ({
  additionalMetadata: {},
  updateMetadata: (key: string, value: any) =>
    set((state) => ({
      additionalMetadata: {
        ...state.additionalMetadata,
        [key]: value,
      },
    })),
  clearMetadata: () => set({ additionalMetadata: {} }),
}));

// Context for provider pattern
interface MetadataContextValue {
  additionalMetadata: Record<string, any>;
}

const MetadataContext = createContext<MetadataContextValue>({
  additionalMetadata: {},
});

export function MetadataProvider({ children }: { children: ReactNode }) {
  const metadata = useMetadata();

  return (
    <MetadataContext.Provider value={{ additionalMetadata: metadata.additionalMetadata }}>
      {children}
    </MetadataContext.Provider>
  );
}
